import { render, staticRenderFns } from "./InputTextFromEnter.vue?vue&type=template&id=0b5ec972"
import script from "./InputTextFromEnter.vue?vue&type=script&lang=ts"
export * from "./InputTextFromEnter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports